import { _proj } from './combo';
import { buildings } from './entities';
import { camera, rig } from './scene';
import { $, clamp } from './util';
import { pickLabels, LabelCand } from './labelpick';

export const labelEls = new Map();
export function rebuildLabels(){
  for (const el of labelEls.values()) el.remove(); labelEls.clear();
  const named = buildings.filter(b => b.userData.name && b.userData.h > 25).sort((a,b)=>b.userData.vol-a.userData.vol).slice(0, 40);
  for (const b of named){ const d = document.createElement('div'); d.textContent = b.userData.name; $('#labels').appendChild(d); labelEls.set(b, d); }
}
const cands: LabelCand[] = []; const pos = new Map<any, { x: number; y: number; dist: number }>();
export function updateLabels(){
  cands.length = 0; pos.clear();
  for (const [b, el] of labelEls){
    if (!buildings.includes(b)){ el.remove(); labelEls.delete(b); continue; }
    const u = b.userData; _proj.set(u.center.x, u.h + 6, u.center.z).project(camera);
    const dist = Math.hypot(u.center.x-rig.base.x, u.center.z-rig.base.z);
    const vis = _proj.z < 1 && Math.abs(_proj.x) < 0.98 && Math.abs(_proj.y) < 0.98 && dist < 900;
    if (!vis){ el.style.display = 'none'; continue; }
    const x = (_proj.x+1)/2*innerWidth, y = (1-_proj.y)/2*innerHeight;
    pos.set(b, { x, y, dist });
    // the ones you're looking at and the ones worth the most, nearer first
    const centre = 1 - Math.hypot(_proj.x, _proj.y) * 0.5;
    cands.push({ key: b, x, y, w: (u.name.length * 7.2 + 8), score: (u.beacon ? 4 : 1) * (0.4 + u.vol / 150000) * centre * (1.3 - dist / 1000) });
  }
  const show = new Set(pickLabels(cands, innerWidth, innerHeight, 7));
  for (const [b, el] of labelEls){
    const p = pos.get(b); if (!p || !show.has(b)){ el.style.display = 'none'; continue; }
    el.style.display = ''; el.style.left = p.x+'px'; el.style.top = p.y+'px';
    el.style.opacity = clamp(1.2 - p.dist/900, 0.3, 1); el.classList.toggle('beacon', !!b.userData.beacon);
  }
}
